// SuperAdminLayout.jsx - Layout for SuperAdmin Dashboard
import React from 'react';
import { AppSidebar } from './AppSidebar';
import { SidebarProvider, SidebarInset } from '../sidebar';
import { Outlet } from 'react-router-dom';

export default function AppLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <SidebarInset style={{ flexGrow: 1, overflowY: 'auto' }}>
          <div className="flex flex-col flex-1 items-center w-full">
            <div className="w-full flex-grow">
              <Outlet />
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}